module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "set-class": 'no-padding',
      "wide": false,
      "width": '500px',
      "min-width": "320px",
      "show-close": true
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [_c('div', [(_vm.passes.length) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skipass.existing-booking-title')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skipass.existing-booking-text')))])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passes.length) ? _c('div', {
    staticClass: "padding center"
  }, [(_vm.passes.length) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.goOn()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skipass.existing-booking-continue')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "padding"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('general.people-count-title')))]), _vm._v(" "), _c('div', {
    staticClass: "blocked center"
  }, [_c('b', {
    staticClass: "uppercase block"
  }, [_vm._v(_vm._s(_vm.$t('skipass.count-title')))]), _vm._v(" "), _c('CounterButton', {
    ref: "counterButton",
    staticClass: "counter-button",
    attrs: {
      "inline": true,
      "count": _vm.peopleCount,
      "min": 1,
      "suffix": ' ' + _vm.$t('general.pieces-short')
    },
    on: {
      "changedCount": function($event) {
        return _vm.changePeople($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "blocked info blue"
  }, [_c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.openPriceList()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skipass.see-pricelist')))])]), _vm._v(" "), _c('div', {
    staticClass: "padding"
  }, [_c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.cta.begin-booking')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.4
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "blocked info green"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skipass.children-free-title')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skipass.children-free-text').replace('55', _vm.SITE_CONFIG.skipass.keycard_price)))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33eb4587"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiPassPickDate.vue
// module id = 941
// module chunks = 0